export default __webpack_public_path__ + "resources/icons/n212-0c44.png";